export default __webpack_public_path__ + "static/media/tier_ranking.aff91b98.png";